import { render } from "./exhibitions-settings.vue?vue&type=template&id=d73e8e60"
import script from "./exhibitions-settings.vue?vue&type=script&lang=js"
export * from "./exhibitions-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__